import React from 'react';

export type TabType = 'plugin' | 'config' | 'history' | 'future';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="tab-navigation">
      <button
        className={`tab-button ${activeTab === 'plugin' ? 'active' : ''}`}
        onClick={() => onTabChange('plugin')}
        aria-label="Plugin Installation and Configuration"
      >
        <span className="tab-icon">📖</span>
        <span className="tab-label">Plugin Installation and Configuration</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'config' ? 'active' : ''}`}
        onClick={() => onTabChange('config')}
        aria-label="TTS Configuration"
      >
        <span className="tab-icon">⚙️</span>
        <span className="tab-label">TTS Configuration</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
        onClick={() => onTabChange('history')}
        aria-label="Audio History"
      >
        <span className="tab-icon">🔊</span>
        <span className="tab-label">Audio History</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'future' ? 'active' : ''}`}
        onClick={() => onTabChange('future')}
        aria-label="Future Plans"
      >
        <span className="tab-icon">💡</span>
        <span className="tab-label">Future Plans</span>
      </button>
    </div>
  );
};

export default TabNavigation;
